module.exports = new __parcel__URL__("cornershop-iphone.95e25651.png").toString();